{
  "labels": {
    "tuje": "Foreign aircraft?",
    "reg": "Registration",
    "masa_plovila": "Teža plovila",
    "klub": "Select club:",
    "stUr": "Number of hours:",
    "stLetov": "Number of flights:",
    "datumN": "Purchase date:",
    "datumR": "Registration date:",
    "vrsta": "Select type:",
    "vlecno": "Tow aircraft:",
    "vlecnoD": "Yes",
    "vlecnoN": "No",
    "opomba": "Note",
    "obracunStevec": "Billing / Service Based on Meter Reading:",
    "razpolozljivost": "Show in availability:",
    "camo_pregled": "Show in CAMO:",
    "camo_flight": "Displaying “Flight” time in CAMO:"
  },
  "buttons": {
    "vnos": "Enter record",
    "brisiIzbiro": "Clear selection"
  }
}